export interface PairedSelectColumn {
  paired_field?: string
  paired_multi?: boolean
}

function scalarValue(value: unknown): unknown {
  if (typeof value === "object" && value !== null && "id" in value) {
    return (value as { id: unknown }).id
  }
  return value
}

export function pairedMultiSelectPatch(
  column: PairedSelectColumn,
  currentValue: unknown,
  optionId: unknown,
  selected: boolean,
  options: PairedSelectOption[],
): { value: unknown[]; paired: Record<string, unknown[]> } {
  const current = Array.isArray(currentValue) ? currentValue.map(scalarValue) : []
  const requested = selected
    ? [...current, optionId]
    : current.filter((value) => value != optionId)
  const orderedOptions = (options || []).filter((option) =>
    requested.some((value) => value == option.id),
  )

  const value = orderedOptions.map((option) => option.id)
  if (!column?.paired_field) return { value, paired: {} }

  return {
    value,
    paired: {
      [column.paired_field]: orderedOptions.map((option) => option.paired_value),
    },
  }
}

export interface PairedSelectOption {
  id: unknown
  paired_value?: unknown
}

export function pairedSelectPatch(
  column: PairedSelectColumn,
  value: unknown,
  options: PairedSelectOption[],
): Record<string, unknown> {
  if (!column?.paired_field) return {}

  const selected = (options || []).find((option) => option.id == value)
  if (!selected || !Object.prototype.hasOwnProperty.call(selected, "paired_value")) return {}

  return { [column.paired_field]: selected.paired_value ?? "" }
}
